/** @format */

import { baseEnvironment } from '../../../shared/config/base-environment';
import { IEnvironment } from '../../../shared/config/environment.interface';

export const environment: IEnvironment = {
  ...baseEnvironment,
  appName: 'Sesio',
  production: true,
  env: 'production',
};
